import { Injector } from '@angular/core';
import { ItemModel } from '../../../../models/itemModel';
import { FrameItem } from '../../../../models/session';
import { ChatGptComponent } from '../../chat-gpt/chat-gpt.component';
import { BoardChatGptConfigurations } from './board-chat-gpt-configurations';
import { BoardApp } from './board-web-viewer';
import { CreationContext } from './board-item-configurations';

export class BoardChatGpt extends BoardApp<BoardChatGptConfigurations> {
  AngularComponentClass = ChatGptComponent;

  constructor(
    injector: Injector,
    configurations: BoardChatGptConfigurations,
    creationContext: CreationContext,
  ) {
    super(injector, ItemModel.Chat_GPT, configurations, creationContext);
  }

  override toFrameItem(): FrameItem {
    const encodedBoardItem = super.toFrameItem();
    return {
      ...encodedBoardItem,
      model: ItemModel.Chat_GPT,
      gpt_state: this.configurations.appConfig,
      isPrivate: this.configurations.isPrivate,
      interactionsLocked: this.configurations.interactionsLocked,
      content_id: this.configurations.chatId,
    };
  }
}
